import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationType } from '@shared-libs/enums';
import { IFormGroup, IResetPasswordConfirmation } from '@shared-libs/interfaces';
import { BasePage } from '@shared-pages/base.page';
import { AuthenticationService } from '@shared-services/authentication.service';
import { NavigationService } from '@shared-services/navigation.service';
import { ResetConfirmFormFactory } from '../../../factories/forms/reset-confirm-form.factory';
import { ResetFormFactory } from '../../../factories/forms/reset-form.factory';
import { PublicUserProvider } from '../../../providers/api/user.provider';

@Component({
	selector: 'reset-page',
	templateUrl: 'reset.page.html',
	styleUrls: ['reset.page.scss'],
})
export class ResetPage extends BasePage {
	public resetRequestForm: IFormGroup<{ username: string }>;
	public resetConfirmForm: IFormGroup<IResetPasswordConfirmation>;
	public code: string;
	public isOk: boolean;

	constructor(
		public readonly authenticationService: AuthenticationService,
		private readonly loginProvider: PublicUserProvider,
		private readonly activatedRoute: ActivatedRoute,
		private readonly navigationService: NavigationService
	) {
		super();
		this.initialize();
		this.activatedRoute.queryParams.subscribe((params) => {
			this.code = params.code || null;
		});
	}

	public initialize(): void {
		this.resetConfirmForm = ResetConfirmFormFactory.create();
		this.resetRequestForm = ResetFormFactory.create();
	}

	public async reset(): Promise<void> {
		if (!this.code && this.resetRequestForm.valid) {
			await this.loginProvider.requestReset(ResetFormFactory.getValue(this.resetRequestForm));
			this.isOk = true;
		} else if (this.code && this.resetConfirmForm.valid) {
			await this.loginProvider.reset({
				code: this.code,
				password: this.resetConfirmForm.value.password.new,
			});
			this.isOk = true;
		}
	}

	public navigateToLogin(): void {
		void this.navigationService.navigateTo(NavigationType.page, '/login').catch();
	}
}
